import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormFieldContext } from '../form-field/form-field.context';
import { ReactComponent as AlertIcError24px } from '../../../assets/icons/alert/ic_error_24px.svg';

const defaultIcons = {
  error: <AlertIcError24px />
};

/**
 * @typedef Props
 * @prop  {React.ReactNode} children
 * @prop  {string} [className]
 * @prop {{error: React.ReactNode}} [icons]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifErrorMessage = (props) => {
  const { children, className = '', icons: userIcons = {}, ...other } = props;
  const icons = {
    ...defaultIcons,
    ...userIcons
  };
  const formField = useContext(FormFieldContext);
  useEffect(() => {
    formField.setInvalid(true);

    return () => {
      formField.setInvalid(false);
    };
  }, []);

  const classes = classNames({
    'motif-error-message': true,
    [className]: true
  });

  return (
    <p role="alert" {...other} className={classes} data-motif-error-message>
      <span className="motif-error-icon">{icons.error}</span>

      {children}
    </p>
  );
};

MotifErrorMessage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icons: PropTypes.shape({
    error: PropTypes.node
  })
};

export { MotifErrorMessage };
